import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import EULAModal from './EULAModal';

const withEulaRestrictions = (WrappedComponent) => {
  class EulaRestrictionsHOC extends React.Component {
    render() {
      const {
        isEulaAccepted,
      } = this.props;
      return (
        <Choose>
          <When condition={!isEulaAccepted && isEulaAccepted !== false}>
            <Page>
              <Loader />
            </Page>
          </When>
          <When condition={isEulaAccepted === false}>
            <EULAModal />
          </When>
          <Otherwise condition={isEulaAccepted}>
            <WrappedComponent {...this.props} />
          </Otherwise>
        </Choose>
      );
    }
  }

  EulaRestrictionsHOC.propTypes = {
    isEulaAccepted: PropTypes.any
  };

  const mapStateToProps = ({ auth }) => ({
    isEulaAccepted: auth.eula,
  });

  return(connect(mapStateToProps)(EulaRestrictionsHOC));
};

export default withEulaRestrictions;



// WEBPACK FOOTER //
// src/components/license/withEulaRestrictions.js